import React, { createContext, useContext, useEffect, useState } from "react";
import api, { onSessionExpired } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking
  const [ready, setReady] = useState(false);

  useEffect(() => onSessionExpired(() => {
    localStorage.removeItem("vt_token");
    setUser(false);
  }), []);

  useEffect(() => {
    if (!user) return;
    let checking = false;
    const checkSession = async () => {
      if (document.visibilityState === "hidden" || checking) return;
      checking = true;
      try {
        await api.get("/auth/me");
      } catch {
        // Only the API's 401 handler expires a session. Network failures and
        // server errors must not sign users out.
      } finally {
        checking = false;
      }
    };
    const timer = window.setInterval(checkSession, 60000);
    window.addEventListener("focus", checkSession);
    document.addEventListener("visibilitychange", checkSession);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("focus", checkSession);
      document.removeEventListener("visibilitychange", checkSession);
    };
  }, [user]);

  useEffect(() => {
    localStorage.removeItem("vt_token");
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("vt_token");
        setUser(false);
      })
      .finally(() => setReady(true));
  }, []);

  const login = (data) => {
    localStorage.removeItem("vt_token");
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("vt_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, updateUser: setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
